export const SESSION_FETCH = 'SESSION_FETCH'
export const SESSION_FETCH_TAX_ACCOUNTANT_TOKEN = 'SESSION_FETCH_TAX_ACCOUNTANT_TOKEN'
export const SESSION_FETCH_ACCESS_TOKEN = 'SESSION_FETCH_ACCESS_TOKEN'
export const SESSION_FETCH_CURRENT_USER = 'SESSION_FETCH_CURRENT_USER'
